import { GralUsrRole } from './GralUsrRole';
export class GralUsr {
  id: number;
  picture: string;
  username: string;
  email: string;
  password: string;
  passwordCrypt: string;
  enabled: boolean;
  publicId: string;
  registrationDate: String;
  ejercicioSeleccionado: boolean | undefined = false;
  gral_usr_role: GralUsrRole[] = [];
  empleado: any;
  empresas: any[] = [{id:0,titulo:'titulo'}];
  empresa_seleccionada: any = {};
}
